// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__JLEAv","tagline":"Footer_tagline__Fb-LW","links":"Footer_links__GfdLj","contact":"Footer_contact__CEgju","bottom":"Footer_bottom__0wC2H"};